/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
export type MemberManagementFormFragment = { teams: Array<{ guid: string, name: string }> };

export const MemberManagementFormFragmentDoc = gql`
    fragment MemberManagementForm on Query {
  teams {
    guid
    name
  }
}
    `;